import React, { memo, useReducer } from 'react';
import { Form } from '@redlink/components/organisms';
import { Space, withPopUp } from '@redlink/components/atoms';
import { FormSection, TextInput } from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import { useMutation, setPageContact } from '@redlink/services';
import { initialState, reducer, types } from './store';
import { freshCache } from './cache';

export const ContactInfoEditPage = withPopUp(
  memo(({ onDismiss, data, pageName, onChange }) => {
    const { dictionary } = useLocale();

    const [{ cellphoneNumber, emailAddress, address }, dispatch] = useReducer(
      reducer,
      initialState(data)
    );

    const [submitSetPageContact, { loading: submitSetPageContactIsLoading }] =
      useMutation(setPageContact, {
        done: () => onDismiss(),
        update: freshCache({ pageName }),
      });

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={submitSetPageContactIsLoading}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.add,
              variant: 'primary',
              onPress: () =>
                onChange
                  ? onChange({cellphoneNumber, emailAddress, address})
                  : submitSetPageContact({
                      cellphoneNumber,
                      emailAddress,
                      address,
                    }),
            },
          ]}
        >
          <FormSection title={dictionary.contactInfo}>
            <TextInput
              title={dictionary.phoneNumber}
              value={cellphoneNumber}
              onChangeText={(value) =>
                dispatch({ type: types.SET_CELLPHONE_NUMBER, payload: value })
              }
            />
            <Space size={16} />
            <TextInput
              title={dictionary.email}
              value={emailAddress}
              onChangeText={(value) =>
                dispatch({ type: types.SET_EMAIL, payload: value })
              }
            />
            <Space size={16} />
            <TextInput
              title={dictionary.address}
              value={address}
              onChangeText={(value) =>
                dispatch({ type: types.SET_ADDRESS, payload: value })
              }
            />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);
